import { useParams } from "react-router-dom";
import { useStudentData } from "@/context";
import { useUserSelector } from "@context/hooks";
import { mapGradeParamIdToGradeCode } from "@utils/routeUtil";

/**
 * Hydration guard for lesson routes.
 *
 * Returns `true` only when all URL-driven state is populated AND
 * consistent with the URL params (grade, term, week, subject, lesson).
 *
 * The lesson layout uses this to defer rendering child routes until
 * state is ready, preventing transient null-state crashes.
 */
const useLessonRouteReady = (): boolean => {
  const { selectedGrade } = useUserSelector();
  const { isDataReady } = useStudentData();
  const { gradeId } = useParams<{ gradeId?: string }>();

  const urlGradeCode = gradeId ? mapGradeParamIdToGradeCode(gradeId) : undefined;

  // Check grade consistency
  if (!selectedGrade) return false;
  if (urlGradeCode && selectedGrade.grade_code !== urlGradeCode) return false;

  // Use the context's isDataReady which checks for required selections
  return isDataReady;
};

export default useLessonRouteReady;
